
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StrategyProviderUser } from './types';
import { Skeleton } from "@/components/ui/skeleton";

interface ExistingUserSelectorProps {
  form: any;
  strategyProviderUsers: StrategyProviderUser[] | undefined;
  isLoadingUsers: boolean;
  hasErrors: boolean;
}

export const ExistingUserSelector = ({ 
  form, 
  strategyProviderUsers = [],
  isLoadingUsers,
  hasErrors 
}: ExistingUserSelectorProps) => {
  return (
    <FormField
      control={form.control}
      name="id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Select Existing User</FormLabel>
          <FormControl>
            {isLoadingUsers ? (
              <Skeleton className="h-10 w-full" />
            ) : (
              <Select 
                onValueChange={field.onChange} 
                defaultValue={field.value}
                disabled={strategyProviderUsers.length === 0}
              >
                <SelectTrigger className={hasErrors ? "border-red-500" : ""}>
                  <SelectValue placeholder="Select a user" />
                </SelectTrigger>
                <SelectContent>
                  {strategyProviderUsers.length === 0 ? (
                    <SelectItem value="no-users" disabled>No strategy provider users available</SelectItem>
                  ) : (
                    strategyProviderUsers.map((user) => (
                      <SelectItem key={user.id} value={user.id}>
                        {user.email} {user.firstName && user.lastName ? `(${user.firstName} ${user.lastName})` : ''}
                      </SelectItem>
                    ))
                  )}
                </SelectContent>
              </Select>
            )}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
